import { connect } from 'react-redux';
import CheckoutPaid from './CheckoutPaid.component';
import {
  getInvoiceForCheckout,
  updateInvoiceXendit,
} from '../../../redux/actions/invoice.actions';

const mapStateToProps = (state) => ({
  invoiceData: state.invoice.checkout,
});

const mapDispatchToProps = {
  getInvoiceForCheckout,
  updateInvoiceXendit,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutPaid);
